import { render, staticRenderFns } from "./statisticnew.vue?vue&type=template&id=54f2747f&scoped=true&"
import script from "./statisticnew.vue?vue&type=script&lang=js&"
export * from "./statisticnew.vue?vue&type=script&lang=js&"
import style0 from "./statisticnew.vue?vue&type=style&index=0&id=54f2747f&lang=less&scoped=true&"
import style1 from "./statisticnew.vue?vue&type=style&index=1&id=54f2747f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2747f",
  null
  
)

export default component.exports